// <copyright file="NotFoundPage.tsx">
// © 2024 Florida Department of Transportation
//
// The copyright to the computer program(s) and source code herein is
// the property of the Florida Department of Transportation.
// The program(s) and source code may be used and/or copied only with the
// written permission of the Florida Department of Transportation or
// in accordance with the terms and conditions stipulated in the
// agreement/contract under which the program(s) and source code have
// been supplied.
// </copyright>

import React from "react";
import styles from "src/components/NotFoundPage/NotFoundPage.module.css";
import type { FC } from "react";

interface NotFoundPageProps {}

const NotFoundPage: FC<NotFoundPageProps> = () => (
    <div className={styles.NotFoundPage} data-testid="NotFoundPage">
        <p>Sorry, the page you are looking for could not be found.</p>
    </div>
);

export default NotFoundPage;
